import * as React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Color from '../../../layouts/Color';

const cardData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const cardNoData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const paddingGrid = { padding: 2 };

export default function ProtraitData(props) {
    const renderProtraitData = (data) => {
        return data !== null ? (
            <Card sx={cardData}>
                <Grid container spacing={3} sx={paddingGrid}>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="body3" color={Color.Normal}> Is match: </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant="body3" color={Color.Normal}> {data.isMatch ? "Match" : "Not match"} </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="body3" color={Color.Normal}> Similarity: </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant="body3" color={Color.Normal}>  {data.similarity.toFixed(2) + "%"} </Typography>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Typography variant="body3" color={Color.Normal}> Is Both Img Card: </Typography>
                    </Grid>
                    <Grid item xs={12} sm={8}>
                        <Typography variant="body3" color={Color.Normal}> {data.isBothImgIDCard ? "Yes" : "No"} </Typography>
                    </Grid>
                </Grid>
            </Card>) : (
            <Card sx={cardNoData}>
           
            </Card>
        );
    }

    return (
        <React.Fragment>
            {renderProtraitData(props.eKycFaceResponse)}
        </React.Fragment>
    );
}